import router from '../../../router';
import pf from '../../../services/pf'

export const savePf = async ({commit}, payload) => {
	let analysis = {
		client_id: payload.id,
		user_id: payload.user_id,
		analysis: {},
		status: 'En curso - iniciado'
	}
	try{
		let data = await pf.save(analysis)
		return Promise.resolve(data)
	} catch (err) {
		return  Promise.reject(err)
	}	
}


export const setAnalisys = async ({commit}, payload) => {
	try {
		let data = await pf.findOne({_id: payload})
		commit('setPF', data)
		if(!data) {
			router.push({name: 'pf-index'})
		}
	} catch (error) {
		
	}
}

export const updatePf = async ({commit}, payload) => {
	try {
		let data = await pf.update(payload)
		commit('setPF', payload)
	} catch (err) {
	}
}
